import { render, staticRenderFns } from "./Desires.vue?vue&type=template&id=34635775&"
import script from "./Desires.vue?vue&type=script&lang=js&"
export * from "./Desires.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../aristotle-website/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports